<template>
  <div class="passwordInput">
    <div class="passwordInput__inputs">
      <FormKit
        :model-value="modelValue"
        :name="name"
        :label="label"
        :type="showPassword ? 'text' : 'password'"
        :validation="validation"
        :validation-messages="validationMessages"
        :help="help"
      />
    </div>
    <div class="passwordInput__icon" @click="toggleShow">
      <i
        :class="{
          fa: true,
          'fa-eye-slash': !showPassword,
          'fa-eye': showPassword
        }"
      ></i>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'PasswordInput',
  props: [
    'name',
    'label',
    'validation',
    'help',
    'modelValue',
    'validationMessages'
  ],
  data() {
    return {
      showPassword: false
    };
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    }
  }
})
export default class PasswordInputComponent extends Vue {}
</script>

<style lang="scss">
.passwordInput {
  width: 100%;
  position: relative;
  .passwordInput__inputs {
    .formkit-outer {
      margin-bottom: 32px;
      .formkit-wrapper {
        .formkit-inner {
          max-width: 377px;
        }
      }
    }
  }
  .passwordInput__icon {
    position: absolute;
    top: 15px;
    right: 16px;
    cursor: pointer;
    .fa-eye,
    .fa-eye-slash {
      width: 18px;
      height: 16px;
      color: $label;
    }
  }
}
</style>
